import { ColDef, ValueGetterParams } from "ag-grid-community";
import { BillingExplorerLabelColumnHeaderCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/header-cell-components/BillingExplorerLabelColumnHeaderCell";
import { LabelColumnCell } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/columns-renderers/label-column/LabelColumnCell";
import { ResourceExplorerGridDataWithId } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";

export interface BillingExplorerLabelColDefProps {
  sortable: boolean;
  pinned: boolean;
}

export const getBillingExplorerLabelColDef = ({
  sortable,
  pinned,
}: BillingExplorerLabelColDefProps): ColDef => ({
  field: "field",
  minWidth: 320,
  flex: 2,
  pinned: pinned ? "left" : undefined,
  sortable,
  lockVisible: true,
  suppressMovable: true,
  suppressColumnsToolPanel: true,
  headerComponentParams: {
    innerHeaderComponent: BillingExplorerLabelColumnHeaderCell,
  },
  comparator: (_, __, nodeA, nodeB) => {
    const current = nodeA.data.label || nodeA.data.field;
    const next = nodeB.data.label || nodeB.data.field;

    return current?.toLowerCase() > next?.toLowerCase() ? -1 : 1;
  },

  valueGetter: ({
    data,
  }: ValueGetterParams<ResourceExplorerGridDataWithId>) => {
    return `${data?.label ?? ""} ${data?.field ?? ""} ${data?.cloud_provider ?? ""}`;
  },

  cellRenderer: LabelColumnCell,
});
